<div class="containerDialog">
  <h2 mat-dialog-title class="titleModal">Adjuntar Servicio a Incidencia</h2>
  <p class="subtitle-text">
    Listado de servicios del file, un servicio puede contener más de una
    incidencia registrada, por lo que es importante revisar el detalle de cada
    servicio antes de adjuntarlo a la incidencia.
  </p>
  <mat-dialog-content class="dialog-content">
    <div *ngIf="loadingTable" class="loading-container">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p class="loading-text">Cargando servicios de file...</p>
    </div>

    <div *ngIf="!loadingTable" class="hidden-wrapper">
      <div class="search-container">
        <mat-form-field appearance="outline" class="search-input-field">
          <mat-label>Buscar servicio</mat-label>
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="Ej. Picnic, Transporte, etc."
          />
          <mat-icon matSuffix class="search-icon">search</mat-icon>
        </mat-form-field>
      </div>

      <div class="table-container mat-elevation-z2">
        <table
          mat-table
          [dataSource]="servicesDataSource"
          matSort
          class="w-100"
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let service">
              <mat-radio-button
                [value]="service"
                [checked]="selectedService === service"
                (change)="selectedService = service"
              >
              </mat-radio-button>
            </td>
          </ng-container>

          <ng-container matColumnDef="activityDayNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Día</th>
            <td mat-cell *matCellDef="let service">
              <span class="day-text">Día {{ service.activityDayNumber }}</span>
              <div class="sub-text">{{ service.activityDayName }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="nombreServicio">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Servicio</th>
            <td mat-cell *matCellDef="let service" class="service-name">
              {{ service.nombreServicio }}
            </td>
          </ng-container>

          <ng-container matColumnDef="tipoServicio">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
            <td mat-cell *matCellDef="let service">
              {{ service.tipoServicio | titlecase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nombreProveedor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Proveedor</th>
            <td mat-cell *matCellDef="let service">
              {{ service.nombreProveedor }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsTable; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let serviceRow; columns: columnsTable"
            class="service-row"
            matTooltipClass="mat-tooltip-multiline"
            [class.selected-row]="selectedService === serviceRow"
            [matTooltip]="
              data.associatedServiceIds &&
              data.associatedServiceIds.includes(serviceRow.id)
                ? '👀Ojo: Este servicio ya cuenta con una incidencia registrada.'
                : ''
            "
            (click)="selectedService = serviceRow"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="5">
              No se encontraron servicios
            </td>
          </tr>
        </table>
      </div>

      <mat-paginator
        [pageSize]="5"
        [pageSizeOptions]="[5, 10, 25, 100]"
      ></mat-paginator>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="containerButtons">
    <button mat-button class="buttonSecondary" (click)="close()">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      class="buttonPrimary"
      [disabled]="!selectedService || loadingTable"
      (click)="saveSelectedService()"
    >
      Adjuntar
    </button>
  </mat-dialog-actions>
</div>
